// extracted by mini-css-extract-plugin
module.exports = {"topToolbar":"EmbedOverlay_topToolbar___QAVn","tooltip":"EmbedOverlay_tooltip__OaYBY","cursor":"EmbedOverlay_cursor__858ML"};